import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext({ company: null, bank: null, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [data, setData] = useState({ company: null, bank: null });

  const refresh = useCallback(() => {
    api.get("/settings/public").then((r) => setData({ company: r.data?.company || null, bank: r.data?.bank_details || null })).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SettingsContext.Provider value={{ ...data, refresh }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);

export const telHref = (phone) => `tel:+${String(phone || "").replace(/\D/g, "").replace(/^(\d{10})$/, "1$1")}`;
export const waHref = (phone) => `https://wa.me/${String(phone || "").replace(/\D/g, "").replace(/^(\d{10})$/, "1$1")}`;
